<template>
  <div class="container-lg bg-white">
    <element-loading :active="loadingIn">
      <img src="img/loading_latino.gif" width="75px" height="75px" style="margin-top: 100px;" />
    </element-loading>

    <div v-if="bSolDatos">

      <div class="row">
        <div class="text-center">
          <img src="img/latino_logo_color.png" class="img-fluid" />
          <h1 style="font-family: 'Montserrat', sans-serif;">ACTUALIZACIÓN DE DATOS FISCALES</h1>
          <p class="fs-4" style="color: #6c757d; font-family: 'Montserrat', sans-serif;">Por favor, ingresa tu R.F.C, número de póliza y número de cliente</p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">R.F.C</label>
          <input type="text" class="form-control border-3" v-model="rfc" placeholder="********">
        </div>
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Número de Póliza</label>
          <input type="text" class="form-control border-3" v-model="poliza" placeholder="********">
        </div>
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Número de Cliente</label>
          <input type="text" class="form-control border-3" v-model="numCli" placeholder="********" data-bs-toggle="tooltip"
            data-bs-placement="bottom" data-bs-title="El número de cliente se encuentra en la carátula de la póliza">
        </div>
      </div>

      <div class="row mt-3">
        <div class="d-grid gap-2 col-2 mx-auto">
          <button class="btn btn-primary fw-bold" type="button" @click="BuscarCli" style="background-color: #44a2f5; border: none; border-radius: 15px;font-family: 'Montserrat', sans-serif;">BUSCAR</button>
        </div>
      </div>

    </div>

    <div v-if="bPerFis">

      <div class="row">
        <div class="text-center">
          <img src="img/latino_logo_color.png" class="img-fluid" />
          <h1 style="font-family: 'Montserrat', sans-serif;">Revisa que tus datos sean correctos</h1>
          <p class="fs-4"  style="color: #6c757d; font-family: 'Montserrat', sans-serif;">Si es necesario cambiar algún otro dato adicional al Régimen fiscal contacta a tu Agente de
            Ventas</p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Nombre</label>
          <input type="text" class="form-control" v-model="nCliente" />
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Apellido Paterno</label>
          <input type="text" class="form-control" v-model="aPaterno" />
        </div>
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Apellido Materno</label>
          <input type="text" class="form-control" v-model="aMaterno" />
        </div>
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Código Postal</label>
          <input type="text" class="form-control" v-model="cPostal" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Régimen Fiscal</label>
          <select v-model="inputRegimenFis" class="custom-select" style="font-family: 'Montserrat', sans-serif;">
            <option v-for="option in ArrayCat" :key="option.id" :value="option.id">{{ option.descripcion }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="d-grid gap-2 col-2 mx-auto">
          <button class="btn btn-primary fw-bold" type="button" @click="GuardarCli" style="background-color: #44a2f5; border: none; border-radius: 15px; font-family: 'Montserrat', sans-serif;">GUARDAR</button>
        </div>
      </div>

    </div>

    <div v-if="bPerMor">
      <div class="row">
        <div class="text-center">
          <img src="img/latino_logo_color.png" class="img-fluid" />
          <h1 style="font-family: 'Montserrat', sans-serif;">Revisa que tus datos sean correctos</h1>
          <p class="fw-bold fs-4" style="color: #6c757d; font-family: 'Montserrat', sans-serif;">Si es necesario cambiar algún otro dato adicional al Régimen fiscal contacta a tu Agente de
            Ventas</p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Razón Social</label>
          <input type="text" class="form-control" v-model="nCliente" />
        </div>
        <div class="col-4">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Código Postal</label>
          <input type="text" class="form-control" v-model="cPostal" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Régimen Capital</label>
          <input type="text" class="form-control" v-model="inputRegimenCap" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="form-label fw-bold" style="font-family: 'Montserrat', sans-serif;">Régimen Fiscal</label>
          <select v-model="inputRegimenFis" class="custom-select" style="font-family: 'Montserrat', sans-serif;">
            <option v-for="option in ArrayCat" :key="option.id" :value="option.id">{{ option.descripcion }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="d-grid gap-2 col-3 mx-auto">
          <button class="btn btn-primary" type="button" @click="GuardarCli" style="background-color: #44a2f5; border: none; font-family: 'Montserrat', sans-serif;">GUARDAR</button>
        </div>
      </div>
    </div>

    <div v-if="modalError" class="modal fade show" tabindex="-1" style="display: block;">
      <div class="text-center">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" style="font-family: 'Montserrat', sans-serif;">Error</h5>
              <button type="button" class="btn-close" aria-label="Close" @click="CerrarModal"></button>
            </div>
            <div class="modal-body">
              <i class="fas fa-times-circle fa-6x" style="color: #d5110a;"></i>
              <h1 class="mt-4" style="color: #4E5556; font-family: 'Montserrat', sans-serif;">¡Error!</h1>
              <h5 class="mt-1" style="color: #4E5556; font-family: 'Montserrat', sans-serif;">{{ msgError }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalExito" class="modal fade show" tabindex="-1" style="display: block;">
      <div class="text-center">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" style="font-family: 'Montserrat', sans-serif;">Éxito</h5>
              <button type="button" class="btn-close" aria-label="Close" @click="CerrarModal"></button>
            </div>
            <div class="modal-body">
              <i class="fas fa-check-circle fa-6x" style="color: #22d50a;"></i>
              <h1 class="mt-4" style="color: #4E5556; font-family: 'Montserrat', sans-serif;">Éxito!</h1>
              <h5 class="mt-1" style="color: #4E5556; font-family: 'Montserrat', sans-serif;">{{ msgExito }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import loading from '../../../componentes/ImgLoading/loading.vue';
export default {
  components: { loading },
  name: 'ActualizarRF',
  data() {
    return {
      usuario: {
        userName: "USU_DELEGADO_CU_WEB",
        password: "123456",
      },
      bSolDatos: false,
      bPerFis: false,
      bPerMor: false,
      loadingIn: false,
      modalError: false,
      modalExito: false,
      numCli: "",
      rfc: "",
      poliza: "",
      REPORTES: "",
      InfoCliente: [],
      CatalogoRegFis: [],
      ArrayCat: [],
      nCliente: "",
      aPaterno: "",
      aMaterno: "",
      cPostal: "",
      IdClienteUni: "",
      IdClienteCen: "",
      IdTipoPer: "",
      IdRegFis: "",
      IdRegCap: "",
      ClaveRegFis: "",
      SiglasRegCap: "",
      ClaveSisCen: "",
      IdCatalogo: "",
      IdSubCatalogo: "",
      inputRegimenCap: "",
      inputRegimenFis: ""
    }
  },
  methods: {
    async login() {
      this.loadingIn = true;
      this.bSolDatos = true;
      this.$store.dispatch("loginDelegadoCU", { usuario: this.usuario });
      this.loadingIn = false;
    },
    BuscarCli() {
      if (this.Validar()) {
        this.loadingIn = true;
        let InfoCliente = {
          "IdCU": this.numCli,
          "RFC": this.rfc,
          "Poliza": this.poliza
        }
        var config = {
          metodo: "BusquedaDelegadoCentrales",
          data: InfoCliente,
        };
 
        this.$store.dispatch("metodoPost", config)
          .then(() => {
            this.InfoCliente = this.$store.getters.getRespuestaREST;
            if (this.InfoCliente.length != 0) {
              let primerObjeto = this.InfoCliente[0];
              // Valores solo para pintar
              this.nCliente = this.ocultarTexto(primerObjeto.NOM_CLIENTE);
              this.aPaterno = this.ocultarTexto(primerObjeto.APELLIDO_PATERNO_CLIENTE);
              this.aMaterno = this.ocultarTexto(primerObjeto.APELLIDO_MATERNO_CLIENTE);
              this.cPostal = primerObjeto.CODIGO_POSTAL;
 
              // Se envían con parametros
              this.IdClienteUni = primerObjeto.ID_CLIENTE_UNICO;
              this.IdClienteCen = primerObjeto.ID_CLIENTE_CENTRAL;
              this.IdTipoPer = primerObjeto.ID_TIPO_PER;
              this.IdRegFis = primerObjeto.ID_REG_FISCAL;
              this.ClaveRegFis = primerObjeto.CVEL_REG_FISCAL;
              this.SiglasRegCap = primerObjeto.SIGLAS_REG_CAPITAL;
              this.ClaveSisCen = primerObjeto.CVE_SISTEMA_CENTRAL;
              console.log("tipo persona : " + this.IdTipoPer + " " + typeof (this.IdTipoPer))
              var data = {
                "IdCatalogo": "36",
                "IdSubCatalogo": this.IdTipoPer
              };
              config = {
                metodo: "GetCatalogoCU",
                data: data,
              };
              return this.$store.dispatch("metodoPost", config); // Devuelve la segunda solicitud
            } else {
              this.loadingIn = false;
              this.msgError = "FAVOR DE CONTACTAR A TU ASESOR DE VENTAS, LAMENTAMOS LAS MOLESTIAS"
              this.modalError = true;
              this.$store.commit("showModal", Modal);
              return Promise.reject(); // Devuelve una promesa RECHAZADA
            }
          })
          .then(() => {
            this.bSolDatos = false;
            this.CatalogoRegFis = this.$store.getters.getRespuestaREST;
            this.CatalogoRegFis.forEach((elemento) => {
              this.ArrayCat.push({
                "descripcion_2": elemento.DESCRIPCION_2,
                "descripcion": elemento.DESCRIPCION,
                "id": elemento.ID
              });
            });
            this.Seleccion()
          })
          .catch((error) => {
            console.error("Error en las solicitudes HTTP:", error);
          });
      } else {
        //this.msgError = "LOS DATOS NO PUEDEN IR VACÍOS"
        //this.modalError = true;
      }
    },
    Seleccion() {
      if (parseInt(this.IdTipoPer) === 1) { // Persona Física
        console.log('PERSONA FÍSICA')
        this.bPerFis = true;
        this.loadingIn = false;
      } else if (parseInt(this.IdTipoPer) === 2) { // Persona moral
        console.log('PERSONA MORAL')
        this.bPerMor = true;
        this.loadingIn = false;
      }
    },
    GuardarCli() {
      if (parseInt(this.IdTipoPer) === 1) { // Persona Física
        console.log("FIS: " + this.inputRegimenFis + " " + typeof (this.inputRegimenFis))
        console.log("CAP: " + this.inputRegimenCap + " " + typeof (this.inputRegimenCap))
        if (this.inputRegimenFis === '') {
          this.loadingIn = true;
          this.bSolDatos = true;
          this.bPerFis = false;
          this.loadingIn = false;
          this.msgError = "NO SE MODIFICO EL RÉGIMEN FISCAL";
          this.modalError = true;
          this.LimpiarVar();
        } else if (this.inputRegimenFis != '') {
          this.loadingIn = true;
          this.ActualizarRF();
          this.bSolDatos = true;
          this.bPerFis = false;
          this.loadingIn = false;
          this.msgExito = "RÉGIMEN FISCAL ACTUALIZADO";
          this.modalExito = true;
          this.LimpiarVar();
        }
      } else if (parseInt(this.IdTipoPer) === 2) { // Persona moral
        console.log("FIS: " + this.inputRegimenFis + " " + typeof (this.inputRegimenFis))
        console.log("CAP: " + this.inputRegimenCap + " " + typeof (this.inputRegimenCap))
        if (this.inputRegimenFis === '' && this.inputRegimenCap === '') { //SI AMBOS CAMPOS VIENEN VACÍOS
          this.loadingIn = true;
          this.bSolDatos = true;
          this.bPerMor = false;
          this.loadingIn = false;
          this.msgError = "EL RÉGIMEN CAPITAL NO FUE ACTUALIZADO / EL RÉGIMEN FISCAL NO FUE ACTUALIZADO"
          this.modalError = true;
          this.LimpiarVar();
        } else if (this.inputRegimenFis != '' && this.inputRegimenCap != '') {
          this.loadingIn = true;
          this.ActualizarRF();
          this.ActualizarRC();
          this.bSolDatos = true;
          this.bPerMor = false;
          this.loadingIn = false;
          this.msgExito = "DATOS FISCALES ACTUALIZADOS";
          this.modalExito = true;
          this.LimpiarVar()
        } else if (this.inputRegimenCap != '' && this.inputRegimenFis === '') {
          this.loadingIn = true;
          this.ActualizarRC();
          this.bSolDatos = true;
          this.bPerMor = false;
          this.loadingIn = false;
          this.msgExito = "RÉGIMEN CAPITAL ACTUALIZADO";
          this.modalExito = true;
          this.LimpiarVar()
        } else if (this.inputRegimenFis != '' && this.inputRegimenCap === '') {
          this.loadingIn = true;
          this.ActualizarRF();
          this.bSolDatos = true;
          this.bPerMor = false;
          this.loadingIn = false;
          this.msgExito = "RÉGIMEN FISCAL ACTUALIZADO";
          this.modalExito = true;
          this.LimpiarVar()
        }
      }
    },
    ActualizarRF() {
      console.log("ID: " + this.inputRegimenFis)
      console.log("CATALOGO: " + this.CatalogoRegFis)
      let objetoEncontrado = null;
      this.CatalogoRegFis.forEach((elemento) => {
        console.log(elemento.ID)
        if (elemento.ID === this.inputRegimenFis) {
          objetoEncontrado = elemento
          console.log(objetoEncontrado)
        }
      })
 
      var data = {
        "IdClienteCU": this.IdClienteUni,
        "IdClienteCentral": this.IdClienteCen,
        "IdRegimenFiscal": objetoEncontrado.ID,
        "IdUsuario": "144997",
        "CveAccion": "ALCC",
        "CveRegFiscal": objetoEncontrado.DESCRIPCION_2,
        "CveSistemaCentral": this.ClaveSisCen
      }
 
      var config = {
        metodo: "ActualizarRegFis",
        data: data
      }
      this.$store.dispatch("metodoPost", config).then(() => {
        this.InfoCliente = this.$store.getters.getRespuestaREST;
        if (this.InfoCliente.length != 0) {
          var Modal = {
            muestra: true,
            color: "info",
            contenido:
              this.InfoCliente,
            boton: "Aceptar",
            titulo: "Reportes Autorservicio",
          };
 
          this.$store.commit("showModal", Modal);
        } else {
          var Modal = {
            muestra: true,
            color: "info",
            contenido:
              "La búsqueda no genero resultados, verifique sus parametros",
            boton: "Aceptar",
            titulo: "Reportes Autorservicio",
          };
 
          this.$store.commit("showModal", Modal);
        }
      });
    },
    ActualizarRC() {
      console.log("CveRegCapital" + this.inputRegimenCap)
      var data = {
        "IdClienteCU": this.IdClienteUni,
        "IdClienteCentral": this.IdClienteCen,
        "IdRegimenCapital": "0",
        "IdUsuario": "144997",
        "CveAccion": "ALCC",
        "CveRegCapital": this.inputRegimenCap,
        "CveSistemaCentral": this.ClaveSisCen
      }
 
      var config = {
        metodo: "ActualizarRegCap",
        data: data
      }
      this.$store.dispatch("metodoPost", config).then(() => {
        this.InfoCliente = this.$store.getters.getRespuestaREST;
        if (this.InfoCliente.length != 0) {
          var Modal = {
            muestra: true,
            color: "info",
            contenido:
              this.InfoCliente,
            boton: "Aceptar",
            titulo: "Reportes Autorservicio",
          };
 
          this.$store.commit("showModal", Modal);
        } else {
          var Modal = {
            muestra: true,
            color: "info",
            contenido:
              "La búsqueda no genero resultados, verifique sus parametros",
            boton: "Aceptar",
            titulo: "Reportes Autorservicio",
          };
 
          this.$store.commit("showModal", Modal);
        }
      });
    },
    ocultarTexto(str) {
      if (str === '') {
        return str
      } else {
 
        // Divide la cadena en palabras
        const palabras = str.split(' ');
 
        // Inicializa una nueva cadena para almacenar el resultado
        let resultado = '';
 
        // Itera a través de las palabras
        for (let i = 0; i < palabras.length; i++) {
          // Obtiene la palabra actual
          const palabra = palabras[i];
 
          // Obtiene la primera letra de la palabra
          const primeraLetra = palabra[0];
 
          // Crea una cadena con asteriscos que tiene la misma longitud que la palabra
          const asteriscos = '*'.repeat(palabra.length - 1);
 
          // Agrega la primera letra y los asteriscos al resultado
          resultado += primeraLetra + asteriscos;
 
          // Agrega un espacio si no es la última palabra
          if (i < palabras.length - 1) {
            resultado += ' ';
          }
        }
 
        return resultado;
      }
    },
    LimpiarVar() {
      this.numCli = "";
      this.rfc = "";
      this.poliza = "";
      this.inputRegimenCap = "";
      this.inputRegimenFis = "";
      this.CatalogoRegFis = [];
      this.ArrayCat = [];
    },
    Validar() {
      var validateOnlyNumbers = new RegExp(/^([0-9])*$/);
      var validateRFC = new RegExp(/^(([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d]))$/);
      if (this.numCli.trim() === '' || this.rfc.trim() === '' || this.poliza.trim() === '') {
        this.msgError = "NINGÚN DATO PUEDE IR VACÍO";
        this.modalError = true;
        return false;
      } else {
        const validations = [
          { condition: !validateOnlyNumbers.test(this.numCli), message: "EL NÚMERO DE CLIENTE NO ES VÁLIDO" },
          { condition: !validateOnlyNumbers.test(this.poliza), message: "EL NÚMERO DE PÓLIZA NO ES VÁLIDO" },
          { condition: !validateRFC.test(this.rfc), message: "EL R.F.C NO TIENE EL FORMATO CORRECTO" }
        ];

        for (const validation of validations) {
          if (validation.condition) {
            this.modalError = true;
            this.msgError = validation.message;
            return false;
          }
        }

        // Si no hay errores, continuar con la lógica principal
        return true;
      }
    },
    CerrarModal() {
      this.modalError = false;
      this.modalExito = false;
    }
  },
  async mounted() {
    this.bSolDatos = true;
    console.log('mounted' + this.bSolDatos)
    await this.login();

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  },
}
</script>

<style scooped>
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1500;
  /* Ajusta el valor según sea necesario */
}
</style>